import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";

@Component({
    selector: 'app-meeting-inspire',
    templateUrl: './meeting-inspire.component.html'
})
export class MeetingInspireComponent implements OnInit {

    public slug;

    post = {
    	"title": null,
        "slug": null,
        "content": null,
        "author": null,
        "thumbnail_image": null
    };

    galleryOptions = [
        {
            width: '600px',
            height: '400px',
            thumbnailsColumns: 4,
        }
    ];
    categories = [];

    author = {};

    galleryImages = [];
    post_images = [];

    constructor(public share: ShareButtons, private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
        });

        this.getPost();
    }

    getPost() {
        this.http.get(Conf.API_URL + '/post/?slug=' + this.slug).subscribe(
            data => {
                this.post = data['results'][0];
		this.getAuthor();
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getAuthor() {
        if (this.post.author) {
            this.http.get(Conf.API_URL + '/author/' + this.post.author + '/').subscribe(
                data => {
                    this.author = data;
                },
                error => {
                    console.log(error.error)
                }
            );
        }
    }

    getPostImages() {
        this.http.get(Conf.API_URL + '/post-images/?things_to_do__slug=' + this.slug).subscribe(
            data => {
                this.post_images = data['results'];

                var this_m = this;

                $.each(this.post_images, function (index, value) {
                    this_m.galleryImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })

                });
            },
            error => {
                console.log(error.error)
            }
        );
    }


}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/meeting-inspire/meeting-inspire.component.ts